<template>
  <main class="bodymain" :class="restData.slug" v-html="myOutput" v-cloak>
  </main>
</template>

<script>

import VueAllInitMixin from '@/mixins/VueAllInit.js';
 
// define a mixin object
export default {
  name: 'page',
    data: () => {
      return {
        mainContent : '',
        restData:{},
        loadedSidebar: '<div id="sidebar">'+document.querySelector('#mysidebar').innerHTML+'</div>'
      }
    },
    components:{
     },
    mixins: [VueAllInitMixin],
    created () {
      this.getMainContent(this.$route);
    },
    beforeMount(){
      
    },
    beforeUpdate(){
      //this.getMainContent(this.$route);
    },
    updated (){
      this.VueAllInit();
      this.$nextTick(()=>{
        this.loadedSidebar='<div id="sidebar">'+document.querySelector('#mysidebar').innerHTML+'</div>';
        //console.log(this.$refs.canvas.clientWidth) //assuming you've added a "canvas" ref
      })      
    },
    computed: {
      myOutput: function () {
        var pattern = 'https://'+this.globalHost+'/jd-news/';
        return this.mainContent.replaceAll(pattern, '/jd-news/') +this.loadedSidebar;
      }
    },
    methods: {
      getMainContent(myPath){
        this.loadingData=true;
        myPath = myPath.path.replace(/\//g, "");
        if (myPath===""){
          myPath="home";
        } else if (this.$route.name==="news") {
          myPath="news";
        }
        this.currentSlug= myPath;
        this.$http.get(
          'wp/v2/pages?slug='+ myPath )
          
        // 'https://dev.johndivalovers.digital-noises.de/wp-json/wp/v2/pages/'+ myPath )
        .then( (response) => {
          // Fpr Slug Based Rest Call
          this.restData = response.data[0];
          this.mainContent = response.data[0].content.rendered;
          // For ID based Rest Call
          //this.mainContent = response.data.content.rendered;
        }).catch(function (error) {

          console.log(error);
        });
      }
    }

}

</script>
<style>
v-cloak{
  visibility: hidden;
  
}

</style>
